'use strict'

const REFRESHABLE_VIEW_TYPES = ['table', 'cards', 'card', 'chart', 'calendar', 'pivot', 'custom']

function pageViews (components) {

  const views = []

  walk(Array.isArray(components) ? components : [], views)

  return views
}

function walk (components, views) {

  for (const component of components) {

    if (!component || typeof component !== 'object') continue

    if (REFRESHABLE_VIEW_TYPES.indexOf(component.type) !== -1 && component.uniqueTitle) {

      const title = typeof component.title === 'string' && component.title.trim()
        ? component.title.trim()
        : component.uniqueTitle

      views.push({
        uniqueTitle: component.uniqueTitle,
        title: title,
        type: component.type,
        label: `${title} (${component.type})`
      })
    }

    if (Array.isArray(component.components)) {

      walk(component.components, views)
    }
  }
}

function eventRefreshesView (event, viewUniqueTitle) {

  const detail = event && event.detail
  const target = detail && detail.viewUniqueTitle

  if (!target) return true

  return target === viewUniqueTitle
}

function fieldIndexMap (fieldCounterMap, fields) {

  if (fieldCounterMap && typeof fieldCounterMap === 'object' && Object.keys(fieldCounterMap).length) {

    return fieldCounterMap
  }

  const map = {}

  if (!Array.isArray(fields)) return null

  for (const field of fields) {

    if (!field || field.columnUniqueTitle == null || field.key == null || field.key === '') continue

    const index = Number(field.key)

    if (Number.isNaN(index)) continue

    map[field.columnUniqueTitle] = index
  }

  return Object.keys(map).length ? map : null
}

module.exports = {
  REFRESHABLE_VIEW_TYPES,
  pageViews,
  eventRefreshesView,
  fieldIndexMap
}
